import { render, staticRenderFns } from "./dangerRecord.vue?vue&type=template&id=ee44af46&scoped=true&"
import script from "./dangerRecord.vue?vue&type=script&lang=js&"
export * from "./dangerRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee44af46",
  null
  
)

export default component.exports